import { createSelector } from 'reselect';
import { getHasOpenActivitySet } from './getHasOpenActivitySet';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';
import { getIsPausedSetup } from './getIsPausedSetup';

/**
 * Determines if there is an open job running.
 *
 * For standard flow: checks if there's an open activity set
 * For async labor ticket flow: labor ticket state is the source of truth
 * Exception: paused setup means there IS an open job (just paused)
 *
 * This is the primary selector for determining if a job is currently running.
 */
const getHasOpenJob = createSelector(
  [
    getHasOpenActivitySet,
    getCurrentLaborTicket,
    getPostLaborUpdatesOnNats,
    getIsPausedSetup,
  ],
  (hasOpenActivitySet, currentLaborTicket, natsFlowEnabled, isPausedSetup) => {
    // Async flow: labor ticket is the source of truth
    if (natsFlowEnabled) {
      if (isPausedSetup) {
        return true; // Paused setup = open job
      }

      if (currentLaborTicket?.state === 'OPEN') {
        return true;
      }

      if (currentLaborTicket?.state === 'CLOSED') {
        const endBehavior = currentLaborTicket?.customFields?.endBehavior;
        // Job is still "open" if endBehavior is 'keep-open' (paused or operator signed out but job continues)
        return endBehavior === 'keep-open';
      }

      return false;
    }

    // Standard flow: check for open activity set
    return hasOpenActivitySet;
  }
);

export { getHasOpenJob };
